@if (icon) {
	<app-icon [name]="icon" size="smallest" color="primary-1"></app-icon>
}
<ng-content></ng-content>
